/** @jsx jsx */
import { __assign, __rest } from "tslib";
import { jsx, css } from '@emotion/react';
import * as React from 'react';
import color from 'color';
import { alpha } from './utils/colors';
import { Spinner } from './Spinner';
import { useTheme } from './theme/Providers';
import { IconWrapper } from './IconWrapper';
import { useTouchable } from 'touchable-hook';
import cx from 'classnames';
import { safeBind } from './hooks/compose-bind';

var getTextColor = function getTextColor(background, theme) {
  return color(background).isDark() ? 'white' : theme.modes.light.text.default;
};

export var getHeight = function getHeight(size) {
  var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
  if (sizes.includes(size)) return '2.625rem';
};
export var getPadding = function getPadding(size) {
  var sizes = ['sm', 'md', 'lg', 'xl'];
  if (size === 'xs') return '0.75rem 0.938rem';
  if (sizes.includes(size)) return '0.75rem 2.375rem';
};
export var getWidth = function getWidth(size, block) {
  if (block) return '100%';
  if (size === 'xs') return '9.375rem';
  if (size === 'sm' || size === 'md') return '19.438rem';
  if (size === 'lg' || size === 'xl') return '21.438rem';
};
export var getFontSize = function getFontSize(size, theme) {
  /* const sizes: string[] = ['xs', 'sm', 'md', 'lg', 'xl']
  if (sizes.includes(size)) return theme.fontSizes[3] */
  var defaultFontSize = theme.fontSizes[2];
  return defaultFontSize;
};
export var getColor = function getColor(disabled, theme, baseColor, isDarkMode) {
  var scales = theme.colors.scales;
  return disabled ? isDarkMode ? scales.grayShades[8] : scales.grayShades[3] : baseColor;
};
export var getDisplay = function getDisplay(block) {
  return block ? 'flex' : 'inline-flex';
};

function gradient(start, end) {
  return "linear-gradient(to top, ".concat(start, ", ").concat(end, ")");
}

function insetShadow(from, to) {
  return "inset 0 0 0 1px ".concat(from, ", inset 0 -1px 1px 0 ").concat(to);
}

export function focusShadow(first, second, third) {
  return "0 0 0 3px ".concat(first, ", inset 0 0 0 1px ").concat(second, ", inset 0 -1px 1px 0 ").concat(third);
}
export var buttonReset = css({
  textDecoration: 'none',
  background: 'none',
  whiteSpace: 'nowrap',
  WebkitAppearance: 'none',
  boxSizing: 'border-box',
  textAlign: 'center',
  WebkitFontSmoothing: 'antialiased',
  border: 'none',
  textRendering: 'optimizeLegibility',
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
  cursor: 'pointer',
  boxShadow: 'none'
});
/**
 * Intent describes the intention of the button
 * -- eg., does it indicate danger?
 */

var getIntentStyles = function getIntentStyles(theme, intent, _hover, active) {
  var dark = theme.colors.mode === 'dark';
  var palette = theme.colors.palette;
  var activeShadow = dark ? insetShadow(alpha(palette.gray.dark, 1), alpha(palette.gray.dark, 0.9)) : insetShadow(alpha(palette.gray.dark, 0.5), alpha(palette.gray.dark, 0.5));

  switch (intent) {
    case 'none':
      {
        return null; // if (dark)
        //   return css([
        //     {
        //       backgroundColor: theme.colors.scales.gray[5],
        //       color: getTextColor(theme.colors.intent.none.base, theme),
        //       background: gradient(
        //         theme.colors.intent.none.base,
        //         lighten(theme.colors.intent.none.base, 0.6)
        //       ),
        //       boxShadow: insetShadow(
        //         alpha(theme.colors.palette.gray.dark, 0.9),
        //         alpha(theme.colors.palette.gray.dark, 0.8)
        //       ),
        //       '&[aria-expanded="true"]': {
        //         background: 'none',
        //         backgroundColor: theme.colors.intent.none.base,
        //         boxShadow: insetShadow(
        //           alpha(palette.gray.base, 1),
        //           alpha(palette.gray.base, 0.9)
        //         )
        //       }
        //     },
        //     active && {
        //       background: 'none',
        //       backgroundColor: theme.colors.intent.none.base,
        //       boxShadow: insetShadow(
        //         alpha(theme.colors.palette.gray.dark, 1),
        //         alpha(theme.colors.palette.gray.dark, 0.9)
        //       )
        //     }
        //   ])
        // return css([
        //   {
        //     backgroundColor: 'white',
        //     color: getTextColor(theme.colors.intent.none.lightest, theme),
        //     background: gradient(theme.colors.intent.none.lightest, 'white'),
        //     boxShadow: insetShadow(
        //       alpha(theme.colors.palette.gray.dark, 0.2),
        //       alpha(theme.colors.palette.gray.dark, 0.1)
        //     ),
        //     '&[aria-expanded="true"]': {
        //       background: 'none',
        //       backgroundColor: theme.colors.intent.none.lightest,
        //       boxShadow: insetShadow(
        //         alpha(palette.gray.dark, 0.3),
        //         alpha(palette.gray.dark, 0.15)
        //       )
        //     }
        //   },
        //   active && {
        //     background: 'none',
        //     backgroundColor: theme.colors.intent.none.lightest,
        //     boxShadow: insetShadow(
        //       alpha(palette.gray.dark, 0.3),
        //       alpha(palette.gray.dark, 0.15)
        //     )
        //   }
        // ])
      }

    case 'primary':
      return css([{
        backgroundColor: theme.colors.intent.primary.base,
        color: getTextColor(theme.colors.intent.primary.base, theme),
        backgroundImage: gradient(theme.colors.intent.primary.base, color(theme.colors.intent.primary.base).lighten(0.4).toString()),
        boxShadow: dark ? insetShadow(theme.colors.palette.gray.dark, theme.colors.palette.gray.dark) : insetShadow(alpha(palette.gray.dark, 0.2), alpha(palette.gray.dark, 0.2)),
        '&[aria-expanded="true"]': {
          boxShadow: activeShadow,
          backgroundImage: gradient(theme.colors.intent.primary.dark, theme.colors.intent.primary.base)
        }
      }, active && {
        boxShadow: activeShadow,
        backgroundImage: gradient(theme.colors.intent.primary.dark, theme.colors.intent.primary.base)
      }]);

    case 'success':
      return css([{
        backgroundColor: theme.colors.intent.success.base,
        color: theme.colors.text.intent,
        backgroundImage: gradient(theme.colors.intent.success.base, color(theme.colors.intent.success.base).lighten(0.5).toString()),
        boxShadow: dark ? insetShadow(theme.colors.palette.gray.dark, theme.colors.palette.gray.dark) : insetShadow(alpha(palette.gray.dark, 0.2), alpha(palette.gray.dark, 0.2)),
        '&[aria-expanded="true"]': {
          boxShadow: activeShadow,
          backgroundImage: gradient(color(theme.colors.intent.success.base).darken(0.2).toString(), theme.colors.intent.success.base)
        }
      }, active && {
        boxShadow: activeShadow,
        backgroundImage: gradient(color(theme.colors.intent.success.base).darken(0.2).toString(), theme.colors.intent.success.base)
      }]);

    case 'danger':
      return css([{
        backgroundColor: theme.colors.intent.danger.base,
        color: theme.colors.text.intent,
        backgroundImage: gradient(theme.colors.intent.danger.base, color(theme.colors.intent.danger.base).lighten(0.3).toString()),
        boxShadow: dark ? insetShadow(theme.colors.palette.gray.dark, theme.colors.palette.gray.dark) : insetShadow(alpha(palette.gray.dark, 0.2), alpha(palette.gray.dark, 0.2)),
        '&[aria-expanded="true"]': {
          boxShadow: activeShadow,
          backgroundImage: gradient(color(theme.colors.intent.danger.base).darken(0.2).toString(), theme.colors.intent.danger.base)
        }
      }, active && {
        boxShadow: activeShadow,
        backgroundImage: gradient(color(theme.colors.intent.danger.base).darken(0.2).toString(), theme.colors.intent.danger.base)
      }]);

    case 'warning':
      return css([{
        backgroundColor: theme.colors.intent.warning.base,
        color: theme.colors.text.intent,
        backgroundImage: gradient(theme.colors.intent.warning.base, color(theme.colors.intent.warning.base).lighten(0.4).toString()),
        boxShadow: dark ? insetShadow(theme.colors.palette.gray.dark, theme.colors.palette.gray.dark) : insetShadow(alpha(palette.gray.dark, 0.2), alpha(palette.gray.dark, 0.2)),
        '&[aria-expanded="true"]': {
          boxShadow: activeShadow,
          backgroundImage: gradient(color(theme.colors.intent.warning.base).darken(0.2).toString(), theme.colors.intent.warning.base)
        }
      }, active && {
        boxShadow: activeShadow,
        backgroundImage: gradient(color(theme.colors.intent.warning.base).darken(0.2).toString(), theme.colors.intent.warning.base)
      }]);
  }
}; // variations to the invisible buttons based on intent


var ghostIntents = function ghostIntents(theme, intent, hover, active) {
  var none = intent === 'none';
  var dark = theme.colors.mode === 'dark';
  var base = none ? theme.colors.palette.green.base : theme.colors.intent[intent].base;

  if (dark && !none) {
    base = theme.colors.intent[intent].light;
  }

  return css([{
    color: none ? theme.colors.palette.green.base : base,
    opacity: 1,
    background: 'transparent',
    boxShadow: 'none',
    transition: 'box-shadow 0.07s cubic-bezier(0.35,0,0.25,1), background 0.07s ' + 'cubic-bezier(0.35,0,0.25,1), opacity 0.35s cubic-bezier(0.35,0,0.25,1)',
    '&[aria-expanded="true"]': {
      background: alpha(base, 0.15),
      boxShadow: 'none',
      opacity: 1
    }
  }, hover && {
    background: alpha(base, 0.07)
  }, active && {
    background: alpha(base, 0.15),
    boxShadow: 'none',
    opacity: 1
  }]);
}; // variations to the outline buttons based on intent


var outlineIntents = function outlineIntents(theme, intent, hover, active) {
  var none = intent === 'none';
  var dark = theme.colors.mode === 'dark';
  var base = none ? theme.colors.palette.green.base : theme.colors.intent[intent].base;

  if (dark && !none) {
    base = theme.colors.intent[intent].light;
  }

  return css([{
    color: base,
    borderColor: alpha(base, 1),
    boxShadow: 'none',
    transition: 'box-shadow 0.07s cubic-bezier(0.35,0,0.25,1), ' + 'background 0.07s cubic-bezier(0.35,0,0.25,1)',
    '&[aria-expanded="true"]': {
      background: alpha(base, 1)
    }
  }, hover && {
    background: alpha(base, 0.05)
  }, active && {
    background: alpha(base, 0.15)
  }]);
};

var getVariantStyles = function getVariantStyles(variant, theme, intent, disabled, circleStop) {
  var notIntent = intent === 'none';
  var isDarkMode = theme.colors.mode === 'dark';
  var _a = theme.colors,
      scales = _a.scales,
      red = _a.palette.red;
  var brandColor = notIntent ? theme.colors.intent.primary : theme.colors.intent[intent];
  var base = brandColor.base,
      light = brandColor.light,
      fullScale = brandColor.fullScale,
      dark = brandColor.dark;
  var variants = {
    default: css([{
      color: disabled ? isDarkMode ? scales.grayShades[6] : scales.grayShades[1] : scales.grayShades[11],
      backgroundColor: getColor(disabled, theme, base, isDarkMode),
      backgroundImage: 'none',
      boxShadow: 'none',
      pointerEvents: disabled ? 'none' : 'auto',
      border: "solid 1px ".concat(getColor(disabled, theme, base, isDarkMode)),
      ':hover': {
        background: light,
        border: "solid 1px ".concat(light)
      },
      ':focus': {
        background: dark,
        border: "solid 1px ".concat(dark)
      }
    }]),
    outline: css({
      color: getColor(disabled, theme, base, isDarkMode),
      border: "solid 1px ".concat(getColor(disabled, theme, base, isDarkMode)),
      pointerEvents: disabled ? 'none' : 'auto',
      background: 'none',
      ':hover': {
        color: light,
        border: "solid 1px ".concat(light)
      },
      ':focus': {
        color: dark,
        border: "solid 1px ".concat(dark)
      }
    }),
    ghost: css({
      background: 'transparent',
      color: getColor(disabled, theme, base, isDarkMode),
      pointerEvents: disabled ? 'none' : 'auto',
      boxShadow: 'none',
      ':hover': {
        color: light
      },
      ':focus': {
        color: dark
      }
    }),
    circle: css({
      pointerEvents: disabled ? 'none' : 'auto',
      background: circleStop ? red.light : fullScale[3],
      boxShadow: 'none',
      width: '5rem',
      height: '5rem',
      padding: 0,
      borderRadius: '50%',
      ':hover': {
        background: circleStop ? red.fullScale[3] : light,
        '> span': {
          background: circleStop ? red.dark : dark
        }
      },
      '> span': {
        background: circleStop ? red.base : base,
        borderRadius: circleStop ? '0.25rem' : '50%',
        width: circleStop ? '2.625rem' : '3.125rem',
        height: circleStop ? '2.625rem' : '3.125rem'
      }
    })
  };
  return variants[variant];
};

var iconSpaceForSize = function iconSpaceForSize(theme) {
  return {
    xs: "calc(".concat(theme.iconSizes.xs, " + 0.6rem)"),
    sm: "calc(".concat(theme.iconSizes.sm, " + 0.6rem)"),
    md: "calc(".concat(theme.iconSizes.md, " + 0.6rem)"),
    lg: "calc(".concat(theme.iconSizes.lg, " + 0.6rem)"),
    xl: "calc(".concat(theme.iconSizes.xl, " + 0.6rem)")
  };
};
/**
 * Your standard Button element
 */


export var ButtonComponent = function ButtonComponent(_a, ref) {
  var _b = _a.size,
      size = _b === void 0 ? 'lg' : _b,
      _c = _a.block,
      block = _c === void 0 ? false : _c,
      _d = _a.variant,
      variant = _d === void 0 ? 'default' : _d,
      _e = _a.circleStop,
      circleStop = _e === void 0 ? false : _e,
      _f = _a.intent,
      intent = _f === void 0 ? 'none' : _f,
      _g = _a.className,
      className = _g === void 0 ? '' : _g,
      _h = _a.disabled,
      disabled = _h === void 0 ? false : _h,
      _j = _a.loading,
      loading = _j === void 0 ? false : _j,
      _k = _a.component,
      Component = _k === void 0 ? 'div' : _k,
      iconBefore = _a.iconBefore,
      iconAfter = _a.iconAfter,
      children = _a.children,
      _l = _a.pressDelay,
      pressDelay = _l === void 0 ? 0 : _l,
      pressExpandPx = _a.pressExpandPx,
      onPress = _a.onPress,
      autoFocus = _a.autoFocus,
      href = _a.href,
      to = _a.to,
      type = _a.type,
      other = __rest(_a, ["size", "block", "variant", "circleStop", "intent", "className", "disabled", "loading", "component", "iconBefore", "iconAfter", "children", "pressDelay", "pressExpandPx", "onPress", "autoFocus", "href", "to", "type"]);

  var theme = useTheme();
  var isLink = to || href;

  var _m = useTouchable({
    onPress: onPress,
    delay: pressDelay,
    pressExpandPx: pressExpandPx,
    disabled: disabled,
    behavior: isLink ? 'link' : 'button'
  }),
      bind = _m.bind,
      hover = _m.hover,
      active = _m.active;

  var intentStyle = React.useMemo(function () {
    return getIntent(variant, intent, theme, hover, active);
  }, [variant, intent, theme, hover, active]);

  if (type === 'submit' && Component === 'div') {
    Component = 'button';
  }

  return jsx(Component, __assign({
    className: cx('Button', 'Touchable', className, {
      'Touchable--hover': hover,
      'Touchable--active': active
    }),
    role: isLink ? 'link' : 'button',
    tabIndex: 0,
    css: [buttonReset, {
      width: getWidth(size, block),
      whiteSpace: size === 'xs' ? 'normal' : 'nowrap',
      fontWeight: 600,
      textTransform: 'uppercase',
      lineHeight: '1.8rem',
      letterSpacing: '0.5%',
      position: 'relative',
      fontFamily: theme.fonts.base,
      borderRadius: size !== 'xs' ? theme.radii.lg : theme.radii.xl,
      fontSize: getFontSize(size, theme),
      padding: getPadding(size),
      height: getHeight(size),
      display: getDisplay(block),
      alignItems: 'center',
      justifyContent: 'center',
      ':focus': {
        outline: theme.outline
      },
      ':focus:not([data-focus-visible-added])': {
        outline: autoFocus ? 'theme.outline' : 'none'
      }
    }, intentStyle, getVariantStyles(variant, theme, intent, disabled, circleStop), loading && {
      '& > :not(.Spinner)': {
        opacity: 0,
        transition: 'opacity 0.1s ease'
      }
    }, (iconBefore || block && iconAfter) && {
      paddingLeft: '0.65rem'
    }, (iconAfter || block && iconBefore) && {
      paddingRight: '0.65rem'
    }]
  }, safeBind(bind, {
    ref: ref
  }, other)), loading && jsx("div", {
    className: 'Spinner',
    css: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }, jsx(Spinner, {
    delay: 1,
    size: size
  })), iconBefore && variant !== 'circle' && jsx(IconWrapper, {
    css: {
      marginRight: theme.spaces.sm
    },
    size: size,
    color: 'currentColor',
    "aria-hidden": true
  }, iconBefore), typeof children === 'string' && variant !== 'circle' ? jsx("span", {
    css: {
      flex: 1,
      // kinda lame hack to center our text in block
      // mode with icons before and after
      marginRight: block && iconBefore && !iconAfter ? iconSpaceForSize(theme)[size] : 0,
      marginLeft: block && iconAfter && !iconBefore ? iconSpaceForSize(theme)[size] : 0
    },
    "aria-hidden": loading
  }, children) : variant !== 'circle' ? children : null, iconAfter && variant !== 'circle' && jsx(IconWrapper, {
    color: 'currentColor',
    css: {
      marginLeft: theme.spaces.sm
    },
    size: size
  }, iconAfter), variant === 'circle' && jsx("span", null));
};
ButtonComponent.displayName = 'Button';
export var Button = React.forwardRef(ButtonComponent);

function getIntent(variant, intent, theme, hover, active) {
  switch (variant) {
    case 'default':
      return getIntentStyles(theme, intent, hover, active);

    case 'ghost':
      return ghostIntents(theme, intent, hover, active);

    case 'outline':
      return outlineIntents(theme, intent, hover, active);
  }
}